import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getPanelAppColorsTotal } from "../../../../state/selectors/CardsUI.selectors";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getPanelAppData } from "../../../../state/selectors/PanelApp.selectors";

const GenePanelAppCard = ({ card, occurences, panelAppData }) => {
  const isDisabled = !panelAppData || !panelAppData.length;

  return (
    <CardWrapper {...card} card={card} isDisabled={isDisabled}>
      {occurences &&
        Object.entries(occurences).map((item) => {
          return (
            <span data-testid={item[0]} key={item[0]}>
              {`${item[0]}: `}
              <span className="tw-font-bold">{`${item[1]} `}</span>
            </span>
          );
        })}
    </CardWrapper>
  );
};

GenePanelAppCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  panelAppData: PropTypes.arrayOf(PropTypes.shape({})),
  occurences: PropTypes.shape({
    Green: PropTypes.number,
    Red: PropTypes.number,
    Amber: PropTypes.number,
  }),
};

GenePanelAppCard.defaultProps = {
  panelAppData: null,
  occurences: null,
};

const mapStateToProps = (state) => ({
  panelAppData: getPanelAppData(state),
  occurences: getPanelAppColorsTotal(state),
});

export default connect(mapStateToProps, {})(GenePanelAppCard);
